import { useEffect, useState } from "react";

export const useIsMobile = (breakpoint: number = 800): boolean => {
  const [isMobile, setIsMobile] = useState<boolean>(() => {
    if (typeof window === "undefined") {
      return false;
    }

    return window.innerWidth < breakpoint;
  });

  useEffect(() => {
    if (typeof window === "undefined") {
      return undefined;
    }

    // Initial check
    const checkIsMobile = (): void => {
      setIsMobile(window.innerWidth < breakpoint);
    };

    // Check on mount
    checkIsMobile();

    // Add event listener
    window.addEventListener("resize", checkIsMobile);

    // Cleanup
    return (): void => window.removeEventListener("resize", checkIsMobile);
  }, [breakpoint]);

  return isMobile;
};
